export const drawImageOnCanvas = async (
    canvasRef: HTMLCanvasElement,
    imageRef: HTMLImageElement
) => {
    return new Promise<boolean>((resolve, reject) => {
        if (imageRef.height === 0 || imageRef.width === 0) {
            reject('Image ref invalid');
            return;
        }

        canvasRef.height = imageRef.height;
        canvasRef.width = imageRef.width;

        // Create an image element in the canvas
        const context = canvasRef.getContext('2d');
        const imageLoad = Object.create(Image.prototype);
        imageLoad.src = imageRef.currentSrc || imageRef.src;
        // Set crossOrigin to allow canvas to read the image (only on local as it's using same origin when deployed)
        import.meta.env.LOCAL_DEVELOPMENT &&
            imageLoad.setAttribute('crossOrigin', '');
        imageLoad.onload = () => {
            context?.drawImage(imageRef, 0, 0, imageRef.width, imageRef.height);
            resolve(true);
        };
    });
};
